var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail-skeleton"},[_c('skeleton-loading',{staticClass:"skeleton-wrapper wrapper"},[_c('div',{staticClass:"detail-skeleton-breadcrumb"},[_c('row',[_c('column',{attrs:{"span":0,"gutter":0}},[_c('square-skeleton',{staticClass:"detail-content-skeleton",attrs:{"box-properties":{
              bottom: '15px',
              width: '340px',
              height: '34px',

            }}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"detail-skeleton-content"},[_c('div',{staticClass:"skeleton-left"},[_c('row',{staticClass:"detail-info-skeleton",style:({marginBottom: '10px',padding: 0}),attrs:{"box-properties":{
            width: '780px',
            height: '120px',
            background: '#fff',
          }}},[_c('column',{attrs:{"span":0,"gutter":0}},[_c('square-skeleton',{staticClass:"detail-content-skeleton",attrs:{"box-properties":{
                bottom: '15px',
                width: '780px',
                height: '25px',

              }}}),_vm._v(" "),_c('square-skeleton',{staticClass:"detail-content-skeleton",attrs:{"count":3,"box-properties":{
                bottom: '15px',
                width: '780px',
                height: '22px',

              }}})],1)],1),_vm._v(" "),_c('row',{staticClass:"detail-hightlights-skeleton",attrs:{"box-properties":{
            width: '780px',
            height: '34px',
          }}},[_c('column',{attrs:{"span":0,"gutter":0}},[_c('square-skeleton',{staticClass:"detail-content-skeleton",attrs:{"box-properties":{
                bottom: '15px',
                width: '780px',
                height: '38px',

              }}})],1)],1),_vm._v(" "),_c('row',{staticClass:"detail-teachers-skeleton",attrs:{"box-properties":{
            width: '780px',
          }}},[_c('column',{staticClass:"detail-teachers-title-skeleton",style:({height: '34px',
                     marginBottom: '14px',
                     marginTop: '34px'}),attrs:{"span":0,"gutter":0}},[_c('square-skeleton',{attrs:{"box-properties":{
                width: '150px',
                height: '34px',

              }}})],1)],1),_vm._v(" "),_c('row',{staticClass:"detail-teachers-list-skeleton",style:({
               display: 'flex',
               justifyContent: 'space-between',
               height: '74px',
             }),attrs:{"box-properties":{
               width: '780px',
               height: '74px!important',

             }}},[_c('square-skeleton',{style:({
              overflow: 'hidden',
              borderRadius: '10px',
              width: '380px',
              height: '74px',
            }),attrs:{"box-properties":{
              height: '74px',

            }}}),_vm._v(" "),_c('square-skeleton',{style:({
              overflow: 'hidden',
              borderRadius: '10px',
              width: '380px',
            }),attrs:{"box-properties":{
              height: '74px',

            }}})],1),_vm._v(" "),_c('row',{staticClass:"detail-suitable-skeleton",attrs:{"box-properties":{
            width: '780px',
          }}},[_c('column',{staticClass:"detail-suitable-title-skeleton",style:({height: '34px',
                     marginBottom: '14px',
                     marginTop: '34px'}),attrs:{"span":0,"gutter":0}},[_c('square-skeleton',{attrs:{"box-properties":{
                width: '150px',
                height: '38px',

              }}})],1)],1),_vm._v(" "),_c('row',{staticClass:"detail-suitable-content-skeleton",style:({lineHeight:'24px',marginBottom: '5px'}),attrs:{"box-properties":{
            width: '780px',
          }}},[_c('column',{attrs:{"span":0,"gutter":0}},[_c('square-skeleton',{attrs:{"box-properties":{
                width: '780px',
                height: '22px',
              }}})],1)],1),_vm._v(" "),_c('row',{staticClass:"detail-suitable-content-skeleton",style:({lineHeight:'24px',marginBottom: '12px'}),attrs:{"box-properties":{
            width: '780px',

          }}},[_c('column',{attrs:{"span":0,"gutter":0}},[_c('square-skeleton',{attrs:{"box-properties":{
                width: '780px',
                height: '22px',

              }}})],1)],1),_vm._v(" "),_c('row',{staticClass:"detail-suitable-img-skeleton"},[_c('column',{attrs:{"span":0,"gutter":0}},[_c('square-skeleton',{style:({
                width: '380px',
                overflow: 'hidden',
                borderRadius: '10px'
              }),attrs:{"box-properties":{
                height: '300px',

              }}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"skeleton-right"},[_c('row',{staticClass:"detail-suitable-radio-skeleton"},[_c('column',{attrs:{"span":20,"gutter":0}},[_c('square-skeleton',{style:({
                width: '400px',
                overflow: 'hidden',
                borderRadius: '10px'
              }),attrs:{"box-properties":{
                height: '284px',

              }}})],1)],1),_vm._v(" "),_c('row',{staticClass:"detail-suitable-info-skeleton"},[_c('column',{attrs:{"span":20,"gutter":0}},[_c('square-skeleton',{style:({
                width: '400px',
                overflow: 'hidden',
                borderRadius: '10px',
                marginBottom: '12px'
              }),attrs:{"box-properties":{
                height: '68px',

              }}})],1)],1),_vm._v(" "),_c('row',{staticClass:"detail-suitable-btn-skeleton",attrs:{"box-properties":{
            width: '400px',
          }}},[_c('column',{attrs:{"span":20,"gutter":0}},[_c('square-skeleton',{style:({
                width: '400px',
                overflow: 'hidden',
                borderRadius: '10px',
                marginTop: '24px'
              }),attrs:{"box-properties":{
                height: '56px',

              }}})],1)],1)],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }